
import {
  Component, Mixins,
} from 'vue-property-decorator';
import TaskEditDialog from '@/components/TaskEditDialog.vue';
import DialogMixin from '@/mixins/DialogMixin.vue';
import UtilsMixin from '@/mixins/UtilsMixin.vue';
import TaskMixin from '@/mixins/TaskMixin.vue';
import { getLeadCustomValueText } from '@/helpers';

@Component({
  components: {
    TaskEditDialog,
  },
})
// eslint-disable-next-line max-len
export default class EditLeadIbanConnessioneDialog extends Mixins(DialogMixin, UtilsMixin, TaskMixin) {
  ibanConnessione: string | null = null

  // Aggiorna i campi con gli eventuali nuovi valori della Lead selezionata
  refreshTask() {
    console.log(`${this.constructor.name}: refreshTask()`); // eslint-disable-line no-console

    this.ibanConnessione = getLeadCustomValueText(this.selectedLead, 'ibanConnessione') ?? null;

    // Richiama il metodo implementato nel mixin
    return this.mixinRefreshTask();
  }

  get ibanRequiredRules() { return this.ibanRules(this.ibanConnessione); }
}
